// extracted by mini-css-extract-plugin
export default {"card":"mZ-z"};